import { IPublicSession } from 'state/session';
import { State } from 'utils/state';
import { fullScreenAutomation } from './fullScreen';
import { syncToServer } from './syncToServer';
import { endSessionCallback } from './endSession';
import { initCarImagesAutoUpdate } from './carImages';
import { experienceSwitchingSanitation } from './experience';
import { initSessionTimeout } from './timeout';
import { endScheduledSessionCallback } from './schedule';

export function initEvents(state: State<IPublicSession>) {
  syncToServer(state);
  fullScreenAutomation(state);
  endSessionCallback(state);
  initCarImagesAutoUpdate(state);
  experienceSwitchingSanitation(state);
  initSessionTimeoutEvents(state);
  endScheduledSessionCallback(state);
}

/**
 * Initialize session timeout events
 * Starts timeout monitoring when a session starts and stops it when session ends
 */
function initSessionTimeoutEvents(state: State<IPublicSession>) {
  // Start timeout monitoring when session starts
  state.on('session:start', () => {
    const timeoutAgent = initSessionTimeout();
    timeoutAgent.start();
  });

  // Start timeout monitoring when session resumes
  state.on('session:resume', () => {
    const timeoutAgent = initSessionTimeout();
    timeoutAgent.start();
  });

  // Stop timeout monitoring when session ends
  state.on('session:end', () => {
    const timeoutAgent = initSessionTimeout();
    timeoutAgent.stop();
  });
}
